export default {
    API_URL: "https://www.dualb.it/api/wp-json/wp/v2/posts"
}